import React from 'react'
import styled from 'styled-components/macro';
import PropTypes from 'prop-types'
import {
  Modifier, EditorState,
} from 'draft-js'
import { getSelectionCustomInlineStyle, getSelectionText } from 'draftjs-utils';
import { forEach } from 'services/helpers'
import { Icon } from 'components/atoms'

export const RichTextEditorOptionClearStyle = ({
  editorState,
  onChange,
}) => {
  const removeAllInlineStyles = editorState => {
    let contentState = editorState.getCurrentContent();
    [
      'BOLD',
      'ITALIC',
      'UNDERLINE',
      'STRIKETHROUGH',
      'MONOSPACE',
      'SUPERSCRIPT',
      'SUBSCRIPT',
    ].forEach(style => {
      contentState = Modifier.removeInlineStyle(
        contentState,
        editorState.getSelection(),
        style
      );
    });
    const customStyles = getSelectionCustomInlineStyle(editorState, [
      'FONTSIZE',
      'FONTFAMILY',
      'COLOR',
      'BGCOLOR',
    ]);

    forEach(customStyles, (key, value) => {
      if (value) {
        contentState = Modifier.removeInlineStyle(
          contentState,
          editorState.getSelection(),
          value
        );
      }
    });

    return EditorState.push(editorState, contentState, 'change-inline-style');
  };

  const removeAllBlockStyles = editorState => {
    const content = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    const newContentState = Modifier.setBlockType(
      content,
      selection,
      'unstyled'
    )

    return EditorState.push(editorState, newContentState, 'change-block-type');
  };

  const removeInlineStyles = () => {
    const editorStateCleanInline = removeAllInlineStyles(editorState)
    const editorStateClean = removeAllBlockStyles(editorStateCleanInline)
    onChange(editorStateClean);
  };

  const handleClick = () => {
    removeInlineStyles()
  }

  const isSelecting = React.useMemo(() => {
    const selectionText = getSelectionText(editorState);
    return Boolean(selectionText)
  }, [editorState])

  return (
    <Option onClick={handleClick}>
      <Icon icon="fas fa-remove-format" height={16} color={isSelecting ? '#000' : '#b6b6b6'} />
    </Option>
  )
}

const Option = styled.div`
    padding: ${props => props.theme.spacing.xs2};
    border-radius: 2px;
    margin: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.bgLighterS};
    font-size: ${props => props.theme.sizes.xs};
    color: ${props => props.theme.colors.baseLighter};

    &:hover {
      background-color: #eee;
    }
`

RichTextEditorOptionClearStyle.propTypes = {
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.shape({}).isRequired,
}


export default RichTextEditorOptionClearStyle
